<template>
    <li class="glide__slide flex justify-center items-center ">
        <slot />
    </li>
</template>

<script>
export default {
}
</script>

<style>
</style>